import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import Alerta from "../components/Alerta/MapContainer";
import "../styles/MapModal.css";


const Mapa = ({
  show,
  handleClose,
  markers,
  handleMarkerClick,
  handleAddMarker,
  onAddressSelect,
  onCoordinatesSelect,
}) => {
  return (
    <Modal 
      show={show} 
      onHide={handleClose} 
      size="xl" 
      className="map-modal"
      backdrop="static"
      keyboard={false}
    >
      <Modal.Body className="map-modal-body">
        <Alerta
          markers={markers}
          handleMarkerClick={handleMarkerClick}
          handleAddMarker={handleAddMarker}
          onAddressSelect={onAddressSelect}
          onCoordinatesSelect={onCoordinatesSelect}
          onCloseModal={handleClose}
        />
      </Modal.Body>
      
      {/* Footer simple sin botón duplicado */}
      <Modal.Footer className="map-modal-footer">
        <div className="modal-footer-info">
          <div className="info-item">
            <i className="fas fa-info-circle"></i>
            <span>Busca una dirección o haz clic en el mapa para marcar la ubicación</span>
          </div>
        </div>
        <Button variant="secondary" onClick={handleClose} className="close-map-btn">
          <i className="fas fa-check"></i>
          Confirmar Ubicación
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default Mapa;
